export const KpiDetails = {
  'Yearly Revenue': {
    unitType: 'currency',
    tooltip:
      'What’s the median revenue a property in this market generated over the last 12 months?',    
  },
  'Cash on Cash Return': {
    unitType: 'percentage',
    tooltip:
      'Cash on Cash Return is a rate of return that calculates the annual cash flow on the cash invested in a property.',
  },
  'Annual rate of return': {
    unitType: 'percentage',
    tooltip:
      'Annual rate of return consists of capital appreciation and cash flow from the rental.',
  },
  'Yearly Net Profit before Tax': {
    unitType: 'currency',
    tooltip:
      'The yearly profit is based on the historical performance of the listings you see on the map combined with the information you provided above.',
  },
  'Monthly Profit': {
    unitType: 'currency',
    tooltip:
      'It is the expected amount of profit you will be generating each month. Monthly Revenue - Monthly Expense = Monthly Profit. It uses historical performance data of the listings you see on the map to calculate Monthly Revenue.',
  },
  Occupancy: {
    unitType: 'percentage',
    tooltip: 'How often was a typical active property occupied over the last 12 months?',
  },
  ADR: {
    unitType: 'currency',
    tooltip: 'How much did hosts in this market charge per day over the last 12 months?',
  },
  'Gross Rental Yield': {
    unitType: 'percentage',
    tooltip:
      "Gross Rental Yield: (Annual Gross Rental Income / Property Price) * 100 \nGross rental yield is the annual gross income generated by an asset, divided by it's price.",
  },
  'Net Rental Yield': {
    unitType: 'percentage',
    tooltip:
      "Net Rental Yield: (Annual Cash Flow / Property Price) * 100 \nNet rental yield is the new annual cash flow generated by an asset, divided by it's price.",
  },
  'Yearly Expense': {
    unitType: 'currency',
    tooltip:
      'The expected annual recurring expenses. The annual expenses typically include Short-term rental license fees, Home Owner Association (HOA) fees, and insurance.',
  },
  '10 years return rate': {
    unitType: 'percentage',
    tooltip: '10 years total captial appreciation gain and total cash flow gain.',
  },
  '3 months profit': {
    unitType: 'currency',
    tooltip: null,
  },
  '6 months profit': {
    unitType: 'currency',
    tooltip: null,
  },
  '12 months profit': {
    unitType: 'currency',
    tooltip: null,
  },
  '24 months profit': {
    unitType: 'currency',
    tooltip: null,
  },
};

export const displayNameToKeyDict = {
  ADR: 'ltm_nightly_rate',
  Occupancy: 'ltm_occupancy_rate',
  'Yearly Revenue': 'ltm_revenue',
  'Yearly Net Profit before Tax': 'yearly_net_profit_before_tax',
  'Monthly Profit': 'monthly_profit',
  'Yearly Expense': 'yearly_expense',
  'Cash on Cash Return': 'cash_on_cash_return',
  'Annual rate of return': 'annual_return_rate',
  'Gross Rental Yield': 'gross_rental_yield',
  'Net Rental Yield': 'net_rental_yeild',
  '10 years return rate': 'return_rate_10_yrs',
  '3 months profit': 'profit_3_months',
  '6 months profit': 'profit_6_months',
  '12 months profit': 'profit_12_months',
  '24 months profit': 'profit_24_months',
};

export const defaultKpiDisplaySchema = {
  buy: [
    { 'Yearly Revenue': 'visible' },
    { 'Cash on Cash Return': 'visible' },
    { 'Annual rate of return': 'visible' },
    { 'Yearly Net Profit before Tax': 'visible' },
    { 'Monthly Profit': 'hidden' },
    { Occupancy: 'hidden' },
    { ADR: 'hidden' },
    { 'Gross Rental Yield': 'hidden' },
    { 'Net Rental Yield': 'hidden' },
    { 'Yearly Expense': 'hidden' },
    { '10 years return rate': 'hidden' },
  ],
  rent: [
    { 'Yearly Revenue': 'visible' },
    { 'Yearly Net Profit before Tax': 'hidden' },
    { 'Monthly Profit': 'visible' },
    { Occupancy: 'visible' },
    { ADR: 'visible' },
    { 'Yearly Expense': 'hidden' },
    { '3 months profit': 'hidden' },
    { '6 months profit': 'hidden' },
    { '12 months profit': 'hidden' },
    { '24 months profit': 'hidden' },
  ],
  manage: [
    { 'Yearly Revenue': 'visible' },
    { 'Yearly Net Profit before Tax': 'visible' },
    { 'Monthly Profit': 'hidden' },
    { Occupancy: 'visible' },
    { ADR: 'visible' },
    { 'Yearly Expense': 'hidden' },
  ],
};
